var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgMessageSquare = function SvgMessageSquare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "message-square_svg__svg-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.414 16.414A2 2 0 0 0 21 15V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v16l4-4h12a2 2 0 0 0 1.414-.586Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export { SvgMessageSquare as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBkPSJNMjAuNDE0MiAxNi40MTQyQzIwLjc4OTMgMTYuMDM5MSAyMSAxNS41MzA0IDIxIDE1VjVDMjEgNC40Njk1NyAyMC43ODkzIDMuOTYwODYgMjAuNDE0MiAzLjU4NTc5QzIwLjAzOTEgMy4yMTA3MSAxOS41MzA0IDMgMTkgM0g1QzQuNDY5NTcgMyAzLjk2MDg2IDMuMjEwNzEgMy41ODU3OSAzLjU4NTc5QzMuMjEwNzEgMy45NjA4NiAzIDQuNDY5NTcgMyA1VjIxTDcgMTdIMTlDMTkuNTMwNCAxNyAyMC4wMzkxIDE2Ljc4OTMgMjAuNDE0MiAxNi40MTQyWiIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+PC9zdmc+";